import React, { useState, useRef, useEffect } from 'react'

import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'

import styles from './Dialog.module.sass'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

const ImportUserDialog = (props) => {
	const { className, dismiss, resolve } = props
	const { i18n } = useGlobal()
	const [username, setUsername] = useState('')
	const [loadingUser, setLoadingUser] = useState(false)
	const [savingUser, setSavingUser] = useState(false)
	const [userData, setUserData] = useState(null)
	const abortControllerRef = useRef(null)

	useEffect(
		() => () => {
			try {
				setLoadingUser(false)
				abortControllerRef.current && abortControllerRef.current.abort()
			} catch (_) {}
		},
		[]
	)

	const loadUserInfo = (e) => {
		e.preventDefault()
		const abortController = new AbortController()
		abortControllerRef.current = abortController
		if (!loadingUser) {
			setLoadingUser(true)
			fetch(
				`${API_URL}/api/users/import/${username}`,
				fetchOptions({ signal: abortControllerRef.current.signal })
			)
				.then((r) => parseJSONContent(r))
				.then((r) => {
					setUserData(r)
					setLoadingUser(false)
				})
				.catch((e) => {
					console.log(e)
					setLoadingUser(false)
				})
		}
	}

	const saveUserData = (e) => {
		e.preventDefault()
		const abortController = new AbortController()
		abortControllerRef.current = abortController
		if (!savingUser) {
			setSavingUser(true)
			fetch(
				`${API_URL}/api/users/import/${username}`,
				fetchOptions({
					signal: abortControllerRef.current.signal,
					method: 'POST',
					body: {
						name: `${userData.user?.firstName} ${userData.user?.lastName}`,
						taskTags: ['test'],
						tags: userData.tags || [],
						rules: (userData.rules || []).map(
							({ variables, output }) => ({
								variables,
								output,
							})
						),
					},
				})
			)
				.then(() => {
					resolve && resolve()
				})
				.catch((e) => {
					console.log(e)
					setSavingUser(false)
				})
		}
	}

	return (
		<>
			<div
				className={`${styles['import-user-root'] || ''} ${
					className || ''
				}`}
			>
				<Widget paddings={['small', '', '']}>
					<form disabled={loadingUser} onSubmit={loadUserInfo}>
						<HStack
							align='center'
							justify='space-between'
							gap='small'
						>
							<TextInput
								placeholder={i18n`Enter a username`}
								value={username}
								onChange={(e) => {
									setUsername(e.target.value)
								}}
							/>
							<ActionButton primary type='submit'>
								<small>
									<strong>{i18n`Load`}</strong>
								</small>
							</ActionButton>
						</HStack>
					</form>
					<small>{loadingUser ? 'Loading' : ' '}</small>
				</Widget>
				{userData && (
					<form id={'form_import_user'} onSubmit={saveUserData}>
						<Widget paddings={['small', '']}>
							<VStack gap='xsmall'>
								<div>
									<h5>
										{userData.user?.firstName}{' '}
										{userData.user?.lastName}
									</h5>
								</div>
								<div>
									<h5>Rules</h5>
									<div className={styles['rules-table']}>
										{userData.rules.map((rule, index) => {
											return (
												<div
													className={
														styles['rule-entry']
													}
													key={index}
												>
													<h6>
														From:{' '}
														{
															rule.importMetadata
																?.profileDescription
														}
													</h6>
													<div>
														{rule.variables?.map(
															(
																variable,
																propIndex
															) => {
																return (
																	<div
																		key={
																			propIndex
																		}
																	>
																		<HStack
																			columns={[
																				1,
																				3,
																			]}
																			gap='xsmall'
																		>
																			<small>
																				<strong>
																					{
																						variable.type
																					}

																					:{' '}
																				</strong>
																			</small>
																			<small>
																				{variable.include?.join(
																					', '
																				)}
																			</small>
																		</HStack>
																	</div>
																)
															}
														)}
													</div>
												</div>
											)
										})}
									</div>
								</div>
								<div>
									<h5>Tags</h5>
									<div className={styles['medium-grid']}>
										{userData.tags.map((tagName, index) => {
											return (
												<span key={index}>
													<small>{tagName}</small>
												</span>
											)
										})}
									</div>
								</div>
							</VStack>
						</Widget>
					</form>
				)}
			</div>
			{userData && (
				<menu>
					<ActionButton secondary onClick={dismiss}>
						<small>
							<strong>Cancel</strong>
						</small>
					</ActionButton>
					<ActionButton
						form={'form_import_user'}
						primary
						onClick={saveUserData}
					>
						<small>
							<strong>Save</strong>
						</small>
					</ActionButton>
				</menu>
			)}
		</>
	)
}

export default ImportUserDialog
